module.exports = __webpack_public_path__ + "img/20.c4fda76b.jpeg";